export default {

  fillCompanyPreview(state, payload) {
    state.preview = payload
  },

  ['login.fill'](state, payload) {
    state.company = payload

    state.failed = false
  },

  ['login.fail'](state, payload) {
    state.failed = true
  },

  //todo - feed from data templates
  ['login.erase'](state, payload) {
    state.company = {
      handle: null
    }
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth/mutations.js